export default "__VITE_ASSET__Cs90gX$K__"